<template>
  <v-list class="pl-list" three-line>
    <deck-list-item
      v-for="deck in currentDecks"
      :deck="deck"
      :key="deck['.key']"/>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import DeckListItem from './DeckListItem'

export default {
  name: 'DeckList',

  components: {
    DeckListItem
  },

  computed: mapGetters('decks', ['currentDecks'])
}
</script>
